// import logo from './logo.svg';
import './App.css';
import { AppKitProvider } from '@reown/appkit/react';
import { networks } from './config/appkit';
import Home from "./pages/Home";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Rule from "./components/Rule";
import Rule3DModel from "./components/Rule3DModel";
// import ConditionsOfPurchase from "./components/ConditionsOfPurchase";
// import PreSale from "./components/PreSale";
// import Minter from "./components/Minter";
// import WalletConnect from "./components/WalletConnect";
import Revving from "./components/Revving";
// import DevRevving from "./components/Dev_Revving";
// import ApiTest from "./components/Api_test";
import LogoGuideline from "./components/LogoGuideline";
// import JsonCreate from "./components/JsonCreate";
import ARJack from "./components/ARJack";
import Firstanniv from "./components/Firstanniv";
import Womb from "./components/Womb";
import { BosoNft, Bosogoods, Rax, Genso, Isekaimeta, Mitama, Oldeus, Machina, Dudu, Cryptosimeji, Kumaleon, Nannda, Dydx, BosoNft2, Bosogoods2, Madworld, Dft, Azito, Gasho, Zenogakki, Owange, Machina2, Hoshiboshi } from "./components/ARJackPrize";
import NotFound from "./components/NotFound";

import { Gallery, Modal, NftPage } from "./components/Gallery";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

// Project IDを環境変数から取得
const projectId = import.meta.env.VITE_PROJECT_ID;


function AppRouter() {
  const location = useLocation();
  const background = location.state && location.state.background;

  return (

    <>
      <Routes location={background || location}>
        <Route index element={<Home />} />
        {/* <Route path="/presale" element={<PreSale />} />
        <Route path="/publicsale" element={<Minter />} /> */}
        <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="rule" element={<Rule />} />
        <Route path="rule3dmodel" element={<Rule3DModel />} />
        {/* <Route path="/conditionsofpurchase" element={<ConditionsOfPurchase />} /> */}
        {/* <Route path="/WalletConnect" element={<WalletConnect />} /> */}
        <Route path="revving" element={<Revving />} />
        {/* <Route path="/dev_revving" element={<DevRevving />} /> */}
        {/* <Route path="/api_test" element={<ApiTest />} /> */}
        <Route path="logoguideline" element={<LogoGuideline />} />
        {/* <Route path="/gallery" element={<Gallery />} /> */}
        {/* <Route path="/jsonCreate" element={<JsonCreate />} /> */}

        {/* bososcramble */}
        <Route path="bososcramble" element={<ARJack />} />
        <Route path="bososcramble/bosonft" element={<BosoNft />} />
        <Route path="bososcramble/bosogoods" element={<Bosogoods />} />
        <Route path="bososcramble/rax" element={<Rax />} />
        <Route path="bososcramble/genso" element={<Genso />} />
        <Route path="bososcramble/isekaimeta" element={<Isekaimeta />} />
        <Route path="bososcramble/mitama" element={<Mitama />} />
        <Route path="bososcramble/oldeus" element={<Oldeus />} />
        <Route path="bososcramble/machina" element={<Machina />} />
        <Route path="bososcramble/dudu" element={<Dudu />} />
        <Route path="bososcramble/cryptosimeji" element={<Cryptosimeji />} />
        <Route path="bososcramble/kumaleon" element={<Kumaleon />} />
        <Route path="bososcramble/nannda" element={<Nannda />} />
        <Route path="bososcramble/dydx" element={<Dydx />} />
        {/* 第二弾 */}
        <Route path="bososcramble/bosonft2" element={<BosoNft2 />} />
        <Route path="bososcramble/bosogoods2" element={<Bosogoods2 />} />
        <Route path="bososcramble/mad" element={<Madworld />} />
        <Route path="bososcramble/dft" element={<Dft />} />
        <Route path="bososcramble/azito" element={<Azito />} />
        <Route path="bososcramble/gasho20" element={<Gasho />} />
        <Route path="bososcramble/projectzenogakki" element={<Zenogakki />} />
        <Route path="bososcramble/owangenft" element={<Owange />} />
        <Route path="bososcramble/machina2" element={<Machina2 />} />
        <Route path="bososcramble/hoshiboshi" element={<Hoshiboshi />} />

        {/* 1stanniv */}
        <Route path="1stanniv" element={<Firstanniv />} />
        <Route path="1stanniv/231029womb" element={<Womb />} />

        {/* gallery */}
        <Route path="gallery" element={<Gallery />} />
        <Route path="gallery/:id" element={<NftPage />} />

        <Route path="*" element={<NotFound />} />
      </Routes>

      {background && (
        <Routes>
          <Route path="gallery/:id" element={<Modal />} />
        </Routes>
      )}
    </>

  );
}

function App() {
  return (
    <AppKitProvider
      projectId={projectId}
      networks={networks}
    >
      <Router>
        <AppRouter />
      </Router>
    </AppKitProvider>
  )
}

export default App;